import { useAppState } from '../context/OmniboxJsonConverterContext';
import { ColumnsList, SelectTemplate } from '.';
import { loadSettings, saveSetting, computeGlobalColumns, createDefaultSettings } from './converterHelperFunctions'
import { generateCsvForEntries } from './csvUtils';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';

import CloseIcon from '@mui/icons-material/Close';



function FileInputModal() {
  const {
    openColumnsDialog, handleCloseColumnsDialog,
    inputFiles, setInputFiles, filesRef, selectedSetting,
    detectedTechnique, selectedColumns,
    setDisplayResults, resetAppState } = useAppState();

  const updateLastUsed = () => {
    const saved = loadSettings();
    if (saved[detectedTechnique]['last_used'] !== selectedSetting) {
      saved[detectedTechnique]['last_used'] = selectedSetting;
      localStorage.setItem('omnibox_json_converter', JSON.stringify(saved));
    }
  }

  const handleRemoveFiles = () => {
    setInputFiles([]);
    handleCloseColumnsDialog();
    // resetAppState();

    if (filesRef.current) {
      filesRef.current.value = '';
    }
  }


  return (
    <Dialog
      open={openColumnsDialog}
      onClose={handleCloseColumnsDialog}
      disableScrollLock
      PaperProps={{
        sx: {
          width: '50%'
        }
      }}
    >
      <DialogTitle
        id='converter-dialog-title'
        sx={{
          // borderBottom: 1, borderColor: 'text.secondary',
          display: 'inline-flex', justifyContent: 'space-between',
          alignItems: 'center', py: 1, pr: 2.5
        }}
      >
        <Stack direction='row' spacing={1} alignItems='center'>
          <Typography variant='caption' fontSize='12px'>
            {inputFiles.length === 0 ? (
              'No Files Selected.'
            ) : (
              `${inputFiles.length} File(s) selected.`
            )}
          </Typography>
        </Stack>
        <IconButton
          onClick={handleCloseColumnsDialog}
          sx={{ p: 0.5 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ pb: 0 }}>
        {inputFiles.length > 0 && (

          <Stack direction='column' spacing={1.5}>

            <SelectTemplate />

            <ColumnsList />

          </Stack>
        )}
      </DialogContent>

      <DialogActions sx={{ mt: 0, py: 1, px: 3 }}>
        <Stack direction='row' spacing={1.5} sx={{ ml: 'auto' }}>
          <Button
            variant='contained'
            size='small'
            onClick={() => {
              const updatedFiles = generateCsvForEntries(inputFiles, selectedColumns);
              setInputFiles(updatedFiles);
              setDisplayResults(true);
              handleCloseColumnsDialog();
              updateLastUsed();
              saveSetting(detectedTechnique, selectedSetting, selectedColumns);
            }}
          >
            Generate CSVs
          </Button>
          <Button
            variant='outlined'
            size='small'
            onClick={handleRemoveFiles}
          >
            Clear Selected Files
          </Button>
        </Stack>
      </DialogActions>

    </Dialog>
  )
}

export default FileInputModal;